import { useSelector } from "react-redux";

const FEATURE_DISABLED_TEXT =
	"The archive feature is not enabled for your firm. Please contact Uptime Legal for more information.";

const MATTERS_RIGHT_DENIED_TEXT =
	"You do not have access to Archive or Unarchive Matters. Please contact your firm administrator for more information.";

const MATTER_CONTENTS_RIGHT_DENIED_TEXT =
	"You do not have access to Archive or Unarchive Matter contents. Please contact your firm administrator for more information.";

function isArchiveFeatureEnabled(state) {
	return !state.tenant.tenantFeaturesLoading
		? state.tenant.tenantFeatures.archiveEnabled === 1
		: false;
}

function makeMemoizedSelector(getInputs, buildResult) {
	let lastInputs = null;
	let lastResult = null;
	return function (state) {
		const inputs = getInputs(state);
		if (
			lastInputs !== null &&
			inputs.every((v, i) => v === lastInputs[i])
		) {
			return lastResult;
		}
		lastInputs = inputs;
		lastResult = buildResult(...inputs);
		return lastResult;
	};
}

export const selectArchiveMattersAccess = makeMemoizedSelector(
	(state) => [
		isArchiveFeatureEnabled(state),
		Boolean(state.user.userRights?.CAN_ARCHIVE_MATTERS),
	],
	(archiveEnabled, canArchive) => ({
		archive: {
			disabled: !archiveEnabled || !canArchive,
			disabledText: !archiveEnabled
				? FEATURE_DISABLED_TEXT
				: MATTERS_RIGHT_DENIED_TEXT,
		},
		unarchive: {
			disabled: !canArchive,
			disabledText: MATTERS_RIGHT_DENIED_TEXT,
		},
	})
);

export const selectArchiveMatterContentsAccess = makeMemoizedSelector(
	(state) => [
		isArchiveFeatureEnabled(state),
		Boolean(state.user.userRights?.CAN_ARCHIVE_MATTER_CONTENTS),
	],
	(archiveEnabled, canArchive) => ({
		archive: {
			disabled: !archiveEnabled || !canArchive,
			disabledText: !archiveEnabled
				? FEATURE_DISABLED_TEXT
				: MATTER_CONTENTS_RIGHT_DENIED_TEXT,
		},
		unarchive: {
			disabled: !canArchive,
			disabledText: MATTER_CONTENTS_RIGHT_DENIED_TEXT,
		},
	})
);

export function useArchiveMattersAccess() {
	return useSelector(selectArchiveMattersAccess);
}

export function useArchiveMatterContentsAccess() {
	return useSelector(selectArchiveMatterContentsAccess);
}
